/**
 * NLB-GW
 *
 * Contact: service@rheinenergie.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * periodic price for given year
 */
export interface TariffPricePeriodicPrices { 
    /**
     * number of year after start of contract, starting with 1
     */
    year?: number;
    /**
     * calculated annual price of tariff
     */
    annualPrice?: number;
    /**
     * calculated monthly price of tariff based on annual price
     */
    monthlyPrice?: number;
}

